export const BIOMETRIC_DO_IT_LATER_STATUS = "BIOMETRIC_DO_IT_LATER_STATUS";
export const NATIVE_DEVICE_INFO = "NATIVE_DEVICE_INFO";
export const INTERNAL_AUTH_TOKEN = "INTERNAL_AUTH_TOKEN";
export const setCookie = (name: string, value: string, days: number) => {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const getCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (const cookie of ca) {
    let c = cookie.trim(); // Directly trim spaces from the start and end
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export const eraseCookie = (name: string) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
